var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path594",
    d: "M0-682.665H21v21H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40963",
    "data-name": "Group 40963",
    transform: "translate(-143 -423)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15547",
    "data-name": "Rectangle 15547",
    width: 24,
    height: 24,
    transform: "translate(143 423)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g588",
    transform: "translate(144.5 1107.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g590",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g592",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path598",
    d: "M272.817-495.283H261.333v-7.383h11.484Z",
    transform: "translate(-253.294 508.203)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "g600",
    transform: "translate(14.93 9.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path602",
    d: "M-144.739-116.308-149.333-120",
    transform: "translate(149.333 120)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g604",
    transform: "translate(8.039 9.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path606",
    d: "M-144.739,0l-4.594,3.691",
    transform: "translate(149.333)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g608",
    transform: "translate(8.039 5.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path610",
    d: "M0,0,5.742,4.614,11.484,0",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g612",
    transform: "translate(1.477 0.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path614",
    d: "M-387.694-155.078v-3.691a1.231,1.231,0,0,0-1.23-1.23h-9.844a1.231,1.231,0,0,0-1.23,1.23v17.309a1.231,1.231,0,0,0,1.23,1.23h9.844a1.231,1.231,0,0,0,1.23-1.23v-6.234",
    transform: "translate(399.999 160)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g616",
    transform: "translate(1.477 16.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path618",
    d: "M-387.694,0H-400",
    transform: "translate(399.999 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g620",
    transform: "translate(6.398 18.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path622",
    d: "M-77.539,0H-80",
    transform: "translate(80 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g624",
    transform: "translate(6.398 3.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path626",
    d: "M-77.539,0H-80",
    transform: "translate(80 0)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g628",
    transform: "translate(10.705 17.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path630",
    d: "M-38.769-19.385a.615.615,0,0,1-.615.615A.615.615,0,0,1-40-19.385.615.615,0,0,1-39.385-20a.615.615,0,0,1,.615.615",
    transform: "translate(40 20)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g632",
    transform: "translate(3.322 17.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path634",
    d: "M0-19.385a.615.615,0,0,0,.615.615.615.615,0,0,0,.615-.615A.615.615,0,0,0,.615-20,.615.615,0,0,0,0-19.385",
    transform: "translate(0 20)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.836c0ab47658cf73fdd635b0f40353ac.svg";
export { ForwardRef as ReactComponent };